import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import List from '../List/List';
import ListItem from '../List/ListItem';
import Modal from './Modal';
import OptInRaffle from './OptInRaffle';
import Raffle from './Raffle';
import Button from '../Button';
import { getActiveRoom } from '~/modules/chat';

interface User {
  username: string;
}

interface RaffleTypeModalProps {
  close: () => void;
  users: User[];
}

function RaffleTypeModal({ close, users }: RaffleTypeModalProps) {
  const [raffleType, setRaffleType] = useState<null | 'manual' | 'optin'>(null);
  const [showReplaceConfirm, setShowReplaceConfirm] = useState(false);
  const [pendingOptIn, setPendingOptIn] = useState(false);

  const currentRoomId = useSelector(getActiveRoom);
  const activeRoom = useSelector(state => state.entities.chatRooms[currentRoomId]);
  const activeOptInRaffle = activeRoom?.raffle && !activeRoom.raffle.finished;

  // Handler for opt-in selection
  const handleOptInClick = () => {
    if (activeOptInRaffle) {
      setShowReplaceConfirm(true);
      setPendingOptIn(true);
    } else {
      setRaffleType('optin');
    }
  };

  if (raffleType === 'manual') {
    return (
      <Raffle users={users} close={close} />
    );
  }

  if (raffleType === 'optin') {
    return (
      <OptInRaffle close={close} />
    );
  }

  if (showReplaceConfirm && pendingOptIn) {
    return (
      <Modal title={"Replace current raffle?"} close={() => setShowReplaceConfirm(false)}>
        <div style={{ textAlign: 'center' }}>
          <FormattedMessage
            id="RaffleType_ReplaceConfirm"
            defaultMessage="An opt-in raffle is already running. Starting a new one will replace the current raffle and remove all participants. Continue?"
          />
          <br /><br />
          <Button onClick={() => setShowReplaceConfirm(false)} style={{ marginLeft: 8 }}>
            <FormattedMessage id="RaffleType_Cancel" defaultMessage="Cancel" />
          </Button>
          <Button onClick={() => { setShowReplaceConfirm(false); setRaffleType('optin'); }}>
            <FormattedMessage id="RaffleType_Replace" defaultMessage="Replace raffle" />
          </Button>
        </div>
      </Modal>
    );
  }

  return (
    <Modal title={<FormattedMessage id="RaffleType_Title" defaultMessage="Raffle type" />} close={close}>
      <List>
        <ListItem
          icon="✍️"
          title={<FormattedMessage id="RaffleType_Normal" defaultMessage="Manual raffle" />}
          description={<FormattedMessage id="RaffleType_NormalDescription" defaultMessage="Let me choose who will participate" />}
          onClick={() => setRaffleType('manual')} />
        <ListItem
          icon="🗳️"
          title={<FormattedMessage id="RaffleType_OptIn" defaultMessage="Opt-in raffle" />}
          description={<FormattedMessage id="RaffleType_OptIn" defaultMessage="Participants enter themselves in the raffle" />}
          onClick={handleOptInClick} />
      </List>
    </Modal>
  );
}

export default RaffleTypeModal;
